<main>
  <!-- Language Selector -->
  <div class="language-selector" style="text-align: right; padding: 10px; font-size: 14px;">
    <span style="margin-right: 10px;">Sprache / Language:</span>
    <button class="btn btn-sm btn-outline-primary" style="margin-right: 5px;" (click)="switchToGerman()">DE</button>
    <button class="btn btn-sm btn-outline-primary" [class.active]="true">EN</button>
  </div>

  <div class="branding" *ngIf="whitelabel != null">
    <app-svg [source]="'whitelabels/' + whitelabel" height="64" width="auto"></app-svg>
  </div>

  <div *ngIf="chargingStation?.lat && chargingStation?.lon" leaflet id="map" [leafletOptions]="mapOptions"
    (leafletMapReady)="onMapReady($event)">
  </div>

  <div *ngIf="isInitiated && chargingStation && pricing; else notAvailable">
    <div class="alert alert-info mb-3" *ngIf="isAuthenticatedWithoutAuthorization" role="alert">
      You are logged in but not authorized for this station. You can charge here directly via QR code — logout is not required.
    </div>
    <div class="card" *ngIf="isAnyChargingPointAvailable; else notReady">
      <!-- <div class="icon"><app-svg source="icons/feather/flag" height="40"></app-svg></div> -->
      <h2 i18n="@@ChargingPointSubcriptionPriceHeader">
        <strong>{{ chargingStation.name }}</strong>
      </h2>

      <span class="price" *ngIf="pricing">
        <strong *ngIf="chargingStation?.model?.profile?.isDc; else priceIsAc">{{ parsePrice(pricing.priceDc) }}</strong>
        <ng-template #priceIsAc>
          <strong>{{ parsePrice(pricing.price) }}</strong>
        </ng-template>
        <small *ngIf="pricing.hasStartingFee">{{ parsePrice(pricing.startingFeeAmount) }} Starting fee per started charging session<br /></small>
        <small i18n="@@PriceUnitIncludeTaxText">per kWh incl. 19%&thinsp;% VAT<br />Minimum amount 1.00 €</small>
      </span>

      <a class="button link mb-3 d-flex gap-0 items-center" (click)="scrollTo('help')" i18n="@@HowChargingWorksText">
        <span>&nbsp;First connect charging cable, then enter payment details</span>
        <app-svg source="icons/feather/help-circle" style="line-height: 0" height="20"></app-svg>
      </a>

      <form [formGroup]="this.subscriptionFormService.form"
        (ngSubmit)="onSubmit(this.subscriptionFormService.form.value)"
        *ngIf="formCreated && this.subscriptionFormService && publicTransactionRequest == null">

        <!--
        Charging point picker.

        If this charging station has only one charging point, the form will be hidden.
        The singular charging point is pre-selected in typescript.

        If this charging station has multiple charging points, the user will select one by the charging point id.
        This point.id means the actual DATABASE INDEX, NOT THE CONNECTOR ID.
        The user will, however, see the connector id as the charging point label.
        -->
        <div>
          <span class="form-label" *ngIf="chargingStation.chargingPoints.length > 1">Please select a charging
            point*</span>
          <div class="form-group" id="charging-point-picker" *ngIf="chargingStation.chargingPoints.length > 1">
            <div *ngFor="let point of chargingStation.chargingPoints; index as i">
              <ng-container *ngTemplateOutlet="chargepointButton, context:{$implicit: point}"></ng-container>
            </div>
            <div class="error" *ngIf="this.subscriptionFormService.hasError('chargingPointId', 'required')">
              <em
                *ngIf="this.subscriptionFormService.validateControl('chargingPointId') && this.subscriptionFormService.hasError('name', 'required')">
                Charging point is required
              </em>
            </div>
          </div>

          <ng-template #chargepointButton let-point>
            <input type="radio" name="charging-point" [id]="'charging-point-' + point.id"
              formControlName="chargingPointId" [value]="point.id"
              [ngClass]="isChargingPointAvailable(point)?'':'disabled'">
            <label [for]="'charging-point-' + point.id" [ngClass]="isChargingPointAvailable(point)?'':'disabled'">
              <span style="display: flex; align-items: center; gap: 4px;">
                <app-svg source="icons/feather/charging-station" style="transform: scaleX(-1)" height="24"
                  style="line-height: 0;"></app-svg>
                {{ point.connectorId }}
              </span>
            </label>
          </ng-template>

          <div class="form-group mb-2">
            <label for="email" class="form-label" i18n="@@E-MailLabel">E-Mail*</label>
            <input type="text" class="form-control" formControlName="email" id="subscription-email"
              i18n-placeholder="@@EmailPlaceholder" placeholder="E-Mail*" ngbAutoFocus />

            <div class="error" *ngIf="this.subscriptionFormService.hasError('email', 'required')">
              <em
                *ngIf="this.subscriptionFormService.validateControl('email') && this.subscriptionFormService.hasError('email', 'required')">E-Mail
                is required</em>
              <em
                *ngIf="this.subscriptionFormService.validateControl('email') && this.subscriptionFormService.hasError('email', 'pattern')">Incorrect
                input</em>
            </div>
            <div *ngIf="!anonymous" class="mt-2">
              <label class="form-label">Billing address*</label>
              <div class="form-group">
                <div class="address-data">
                  <!-- <input type="text" class="form-control" formControlName="company" id="subscription-company" placeholder="Company" /> -->
                  <input type="text" class="form-control" formControlName="name" id="subscription-name"
                    placeholder="Name*" />
                  <input type="text" class="form-control" formControlName="street" id="subscription-street"
                    placeholder="Street*" />
                  <input type="text" class="form-control" formControlName="housenumber" id="subscription-housenumber"
                    placeholder="House number*" />
                  <input type="text" class="form-control" formControlName="postcode" id="subscription-postcode"
                    placeholder="ZIP code*" />
                  <input type="text" class="form-control" formControlName="city" id="subscription-city"
                    placeholder="City*" />
                </div>

                <div class="error" *ngIf="
                                  this.subscriptionFormService.hasError('street', 'required') ||
                                  this.subscriptionFormService.hasError('housenumber', 'required') ||
                                  this.subscriptionFormService.hasError('postcode', 'required') ||
                                  this.subscriptionFormService.hasError('city', 'required')
                                  ">
                  <em
                    *ngIf="this.subscriptionFormService.validateControl('name') && this.subscriptionFormService.hasError('name', 'required')">Name
                    is required</em>
                  <em
                    *ngIf="this.subscriptionFormService.validateControl('street') && this.subscriptionFormService.hasError('street', 'required')">Street
                    is required</em>
                  <em
                    *ngIf="this.subscriptionFormService.validateControl('housenumber') && this.subscriptionFormService.hasError('housenumber', 'required')">House
                    number
                    is required</em>
                  <em
                    *ngIf="this.subscriptionFormService.validateControl('postcode') && this.subscriptionFormService.hasError('postcode', 'required')">ZIP
                    code
                    is required</em>
                  <em
                    *ngIf="this.subscriptionFormService.validateControl('city') && this.subscriptionFormService.hasError('city', 'required')">City
                    is required</em>
                </div>
              </div>
            </div>
          </div>

          <!--CheckBox-->
          <div>
            <!--CheckBoxAnonym-->
            <div class="form-check mb-2">
              <input class="form-check-input" type="checkbox" id="anonymous" formControlName="anonymous" />
              <label class="form-check-label" for="anonymous" i18n="@@anonymousDescription">
                I want to remain anonymous and waive providing my personal data (name and address) for the invoice.
              </label>
            </div>
          </div>

          <ng-container *ngIf="hasStoredAccessToken && loginUrl && !isAuthenticated">
            <hr>
            <label class="form-label" i18n="@@AlreadyHaveAccountLabel">Already have an account?</label>
            <div class="text-center mb-3">
              <a class="btn btn-default w-100" [href]="loginUrl" i18n="@@LoginForRemoteStartButton">Login</a>
            </div>
          </ng-container>

          <hr>
          <div>
            <!--CheckBoxAgb-->
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="agbConfirm" formControlName="agbConfirm" />
              <label class="form-check-label" for="agbConfirm" i18n="@@agbConfirmDescription">
                I have read the
                <a href="https://uploads-ssl.webflow.com/63d9fc1e4a5c00a5ee5b1f3f/63e24d8ae16849e8e26e42a5_cubos_agb.pdf"
                  target="_blank" class="link-yellow" style="cursor: pointer;">Terms and Conditions</a>
                of CUBOS Service GmbH and agree to them.
              </label>
            </div>
            <!--CheckBoxDsb-->
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="dsbConfirm" formControlName="dsbConfirm" />
              <label class="form-check-label" for="dsbConfirm" i18n="@@dsbConfirmDescription">
                I have read the
                <a data-bs-toggle="modal" data-bs-target="dsModal" class="link-yellow" style="cursor:pointer;"
                  (click)="openDSDialog()">Privacy Policy</a>
                of CUBOS Service GmbH and agree to it.
              </label>
            </div>
            <!--CheckBoxBookingPolicy-->
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="bookingConfirm" formControlName="bookingConfirm" />
              <label class="form-check-label" for="bookingConfirm" i18n="@@bookingConfirmDescription">
                I hereby confirm that an amount of 60 € will be reserved on my selected payment method.
                After completion of the charging process, the actual invoice amount will be debited from my account and
                the excess amount will be refunded.
              </label>
            </div>
          </div>

          <div class="pt-1 mt-4 text-center" *ngIf="formCreated && publicTransactionRequest == null">
            <button style="grid-column: span 12" type="submit" id="confirm_subcription" class="button hero"
              [disabled]="!this.subscriptionFormService.form.valid">
              <span *ngIf="!isCreatingStripeForm">Continue to payment</span>
              &nbsp;<app-svg source="icons/feather/loader" class="loading" height="24"
                *ngIf="isCreatingStripeForm && publicTransactionRequest == null"></app-svg>
            </button>
          </div>
        </div>
      </form>

      <form method="post" id="payment-form"
        [style]="publicTransactionRequest == null ? 'opacity: 0; max-height: 0px; overflow: hidden;' : ''">
        <ng-container *ngTemplateOutlet="precisionChargeTemplate"></ng-container>
        <hr>
        <div id="payment-element">
          <h2>Please select a payment method.</h2>
          <div id="card-element"></div>
          <div id="error-message"></div>
        </div>

        <div id="block-info" class="mt-4">
          <app-svg source="icons/feather/info" height="20"></app-svg>
          <span>An amount of {{this.chargingAmountPreview | number:'1.2-2':'de-DE'}} € will be reserved on your account
            until the final invoice amount is debited after completion of the charging process.</span>
        </div>

        <div class="pb-3 mt-4 text-center">
          <button *ngIf="formCreated && isCreatingStripeForm && publicTransactionRequest != null"
            style="grid-column: span 12" type="submit" class="button hero">
            <span *ngIf="!isPaying">Pay and charge</span>
            &nbsp;<app-svg source="icons/feather/loader" class="loading" height="24" *ngIf="isPaying"></app-svg>
          </button>

        </div>
        <button class="button link d-flex gap-0 items-center" type="button" (click)="pageBack()">
          <app-svg source="icons/feather/arrow-left-circle" style="line-height: 0;"
            height="20"></app-svg><span>&nbsp;Back</span>
        </button>
      </form>
    </div>

    <div class="card" id="help">
      <h3 (click)="toggleDrawer()" i18n="@@SimpleConvenientHeader"
        style="display: flex; justify-content: space-between; align-items: center; cursor: pointer;">
        Detailed instructions
        <app-svg [source]="'icons/feather/chevron-down'" [ngClass]="{'rotate-icon': drawerOpen}" height="24"></app-svg>
      </h3>
      <div [@drawerState]="drawerOpen ? 'open' : 'closed'">
        <ol>
          <li>Connect the charging cable to the vehicle</li>
          <li>Enter your e-mail address and click "Continue to payment".</li>
          <li>Select payment method and optionally set charging amount limit.</li>
          <li>60 euros will be reserved on the payment method to authorize the charging process. Your payment method
            provider may require authorization.</li>
          <li>Once successfully authorized, the charging process starts automatically.</li>
          <li>You can end the charging process at any time via your vehicle. Additionally, you will receive an e-mail
            with a link at the start of charging to end the process via our website. If a charging amount limit has been
            activated, it will automatically trigger when the set limit is reached.</li>
          <li>After ending the charging process, the actual invoice amount will be debited and the excess amount
            refunded. The invoice will also be sent automatically to the provided e-mail address.</li>
        </ol>
      </div>
    </div>

    <ng-container *ngIf="chargingStation?.chargingPoints?.length">
      <div class="form-group mb-4 mx-auto" style="max-width: 740px; padding: 0 32px;">
        <strong i18n="@@EvseIdListLabel">EVSE-IDs</strong>
        <div *ngFor="let point of chargingStation.chargingPoints">
          <span i18n="@@ChargePointLabel">Charging point</span> {{ point.connectorId }}: {{ point.evseId }}
        </div>
      </div>
    </ng-container>

    <p *ngIf="chargingStation.hotlinePhoneNumber" style="text-align: center; margin-bottom: 1.5rem;">
      <strong>Hotline</strong><br />
      <strong style="font-size: 1.5rem; font-weight: 900">{{ chargingStation.hotlinePhoneNumber }}</strong>
    </p>

    <p *ngIf="chargingStation.customer" i18n="@@ChargingPointElectricityProviderInfoText">
      Charging point and electricity provided by <a *ngIf="parkOwner && parkOwner.email else company"
        [href]="'https://www.'+parkOwner.email.split('@')[1]" target="_blank">{{ chargingStation.customer.name }}</a>.
      <ng-template #company>{{ chargingStation.customer.name }}</ng-template>
    </p>
    <p>
      <img src="assets/favicon-32x32.png" alt="CUBOS" />
      <a href="https://www.cubos.com" target="_blank"><strong>Powered&nbsp;by CUBOS</strong></a>
      <span>&copy; Copyright&nbsp;{{ getFullYear() }} CUBOS&nbsp;Service&nbsp;GmbH. All rights reserved.</span>
    </p>
  </div>
</main>

<ng-template #precisionChargeTemplate>
  <div class="precisionChargeCheckbox mb-2">
    <input class="form-check-input" type="checkbox" id="precisionChargeCheckbox" (change)="togglePrecisionCharge()" />
    <label class="form-check-label" for="precisionChargeCheckbox" i18n="@@precisionChargeCheckboxLabel">I want to limit
      the charging amount</label>
  </div>

  <div class="precisionCharging mb-2" *ngIf="precisionCharge">
    <div id="block-info">
      <app-svg source="icons/feather/info" height="20"></app-svg>
      <span><b>Please note that the limitation only has an accuracy of 0.5 kWh. The kWh output is legally compliant. The
          invoice will be created based on the actually output kWh.</b></span>
    </div>

    <div class="toggle-unit rounded-pill" (click)="toggleUnit()">
      <h5 [ngClass]="{'active': chargingUnit == 'euro'}">Euro</h5>
      <h5 [ngClass]="{'active': chargingUnit == 'kwh'}">kWh</h5>
    </div>
    <div class="slider" [ngClass]="{'slide-euro': chargingUnit == 'euro', 'slide-kwh': chargingUnit == 'kwh'}"></div>

    <div class="select-amount" *ngIf="chargingUnit == 'euro'">
      <div>
        <button [ngClass]="{'active': chargingUnit == 'euro' && chargingAmount == 500}" type="button" class="btn"
          value="500" (click)="selectAmount(500)">5&nbsp;€</button>
        <button [ngClass]="{'active': chargingUnit == 'euro' && chargingAmount == 1000}" type="button" class="btn"
          value="1000" (click)="selectAmount(1000)">10&nbsp;€</button>
      </div>
      <div>
        <button [ngClass]="{'active': chargingUnit == 'euro' && chargingAmount == 2000}" type="button" class="btn"
          value="2000" (click)="selectAmount(2000)">20&nbsp;€</button>
        <button [ngClass]="{'active': chargingUnit == 'euro' && chargingAmount == 3000}" type="button" class="btn"
          value="3000" (click)="selectAmount(3000)">30&nbsp;€</button>
      </div>
    </div>

    <div class="select-amount" *ngIf="chargingUnit == 'kwh'">
      <div>
        <button [ngClass]="{'active': chargingUnit == 'kwh' && chargingAmount == 500}" type="button" class="btn"
          value="500" (click)="selectAmount(500)">5&nbsp;kWh</button>
        <button [ngClass]="{'active': chargingUnit == 'kwh' && chargingAmount == 1000}" type="button" class="btn"
          value="1000" (click)="selectAmount(1000)">10&nbsp;kWh</button>
      </div>
      <div>
        <button [ngClass]="{'active': chargingUnit == 'kwh' && chargingAmount == 2000}" type="button" class="btn"
          value="2000" (click)="selectAmount(2000)">20&nbsp;kWh</button>
        <button [ngClass]="{'active': chargingUnit == 'kwh' && chargingAmount == 3000}" type="button" class="btn"
          value="3000" (click)="selectAmount(3000)">30&nbsp;kWh</button>
      </div>
    </div>

    <div class="error align-self-start" *ngIf="!chargingAmount" style="margin-top: -0.7rem">
      <em>Maximum charging amount is required</em>
    </div>
  </div>
</ng-template>

<ng-template #notAvailable>
  <div class="wrapper">
    <div class="card" *ngIf="isInitiated; else notInitiated">
      <div class="icon"><app-svg source="icons/feather/zap-off" height="40"></app-svg></div>
      <h2 *ngIf="chargingStation" i18n="@@NotAvailableHeader"><strong>{{ chargingStation.name }}</strong> is not
        available</h2>
      <h2 *ngIf="!chargingStation" i18n="@@ChargePointNotAvailableHeader">The charging point is not available</h2>
      <ng-container *ngIf="hasStoredAccessToken && loginUrl && !isAuthenticated">
        <hr>
        <p class="form-label text-center" i18n="@@LoginUnavailableFallbackLabel">Please login for remote start.</p>
        <div class="text-center mt-2 mb-3">
          <a class="btn btn-default w-100" [href]="loginUrl" i18n="@@LoginForRemoteStartButton">Login</a>
        </div>
      </ng-container>
    </div>
  </div>
</ng-template>

<ng-template #notInitiated>
  <div class="card">
    <div class="icon"><app-svg source="icons/feather/loader" class="loading" height="40"></app-svg></div>
    <h2 *ngIf="chargingStation"><strong>{{ chargingStation.name }}</strong> is being requested</h2>
    <h2 *ngIf="!chargingStation">The charging point is being requested</h2>
  </div>
</ng-template>

<ng-template #notReady>
  <div class="card">
    <div class="icon"><app-svg source="icons/feather/lock" height="40"></app-svg></div>
    <h2 i18n="@@ChargingPointNotAvailableHeader"><strong>{{ chargingStation.name }}</strong> is not available</h2>
    <ng-container *ngIf="hasStoredAccessToken && loginUrl && !isAuthenticated">
      <hr>
      <p class="form-label text-center" i18n="@@LoginUnavailableFallbackLabel">Please login for remote start.</p>
      <div class="text-center mt-2 mb-3">
        <a class="btn btn-default w-100" [href]="loginUrl" i18n="@@LoginForRemoteStartButton">Login</a>
      </div>
    </ng-container>
  </div>
</ng-template>